import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight, Loader2 } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/app/dashboard");
    } catch (_) {} finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-black text-white p-12 grid-pattern">
        <Link to="/" className="font-display text-2xl tracking-tighter" data-testid="auth-logo">EAG <span className="text-[#FF2B00]">●</span></Link>
        <div>
          <h1 className="font-display text-5xl tracking-tighter leading-[1]">The administrator's<br/>command center.</h1>
          <p className="mt-6 text-zinc-400 max-w-md">Carwash, detail, porter, bodyshop, and onboarding — all under one AI-guided workspace.</p>
        </div>
        <div className="label-caps text-zinc-500">© EAG ● Dealership Services OS</div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8">
            <Link to="/" className="font-display text-2xl tracking-tighter">EAG <span className="text-[#FF2B00]">●</span></Link>
          </div>
          <div className="label-caps text-[#FF2B00] mb-3">Welcome back</div>
          <h2 className="font-display text-4xl tracking-tighter">Sign in</h2>
          <p className="text-zinc-600 mt-2 text-sm">Use your EAG admin / employee / dealership credentials.</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="label-caps block mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-black px-4 py-3 focus:outline-none focus:border-[#FF2B00]"
                placeholder="admin@eag.com"
              />
            </div>
            <div>
              <label className="label-caps block mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-black px-4 py-3 focus:outline-none focus:border-[#FF2B00]"
                placeholder="••••••••"
              />
            </div>
            {error && <div data-testid="login-error" className="text-sm text-[#FF2B00]">{error}</div>}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={busy}
              className="w-full bg-black text-white py-3 hover:bg-[#FF2B00] disabled:opacity-50 label-caps inline-flex items-center justify-center gap-2"
            >
              {busy ? <Loader2 className="animate-spin" size={16} /> : <>Sign in <ArrowRight size={16} /></>}
            </button>
          </form>
          <p className="mt-8 text-sm text-zinc-600">
            Don't have an account?{" "}
            <Link to="/register" data-testid="login-to-register" className="text-black underline hover:text-[#FF2B00]">Register</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
